module.exports = __webpack_public_path__ + "img/cross1blue.b0446ddb.png";